import * as React from 'react';
const IconNavSearch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 36 39"
    fill="none"
    style={{ width: '24px', height: '25px' }}
    {...props}
  >
    <circle cx={14.739} cy={14.739} r={12.739} stroke="white" strokeWidth={4} />
    <path
      d="M27.263 37.3218C29.0975 39.3857 32.2579 39.5716 34.3218 37.737C36.3857 35.9025 36.5716 32.7421 34.737 30.6782L31 34L27.263 37.3218ZM23 25L19.263 28.3218L27.263 37.3218L31 34L34.737 30.6782L26.737 21.6782L23 25Z"
      fill="white"
    />
  </svg>
);
export default IconNavSearch;
